import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

interface StickyCallBarProps {
  language: 'he' | 'en' | 'ru';
}

const translations = {
  he: {
    call: 'התקשרו עכשיו',
    whatsapp: 'WhatsApp',
  },
  en: {
    call: 'Call Now',
    whatsapp: 'WhatsApp',
  },
  ru: {
    call: 'Позвонить',
    whatsapp: 'WhatsApp',
  },
};

// Pre-filled WhatsApp message
const WHATSAPP_MESSAGE = encodeURIComponent('היי! אני מעוניין/ת לקבוע תור לטיפוח. 🐕');
const WHATSAPP_URL = `https://wa.me/972555171717?text=${WHATSAPP_MESSAGE}`;
const PHONE_NUMBER = 'tel:+972772200052';

export function StickyCallBar({ language }: StickyCallBarProps) {
  const t = translations[language];

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden"
      style={{ 
        background: 'linear-gradient(135deg, #F29B70 0%, #E8926A 100%)',
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.15)',
      }}
    >
      <div className="flex">
        {/* Call Button */}
        <a
          href={PHONE_NUMBER}
          className="flex-1 flex items-center justify-center gap-2 py-4 text-white font-semibold transition-all active:scale-95"
          style={{ 
            borderRight: '1px solid rgba(255,255,255,0.2)',
          }}
        >
          <Phone size={22} className="animate-pulse" />
          <span>{t.call}</span>
        </a>
        
        {/* WhatsApp Button */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-2 py-4 text-white font-semibold transition-all active:scale-95"
          style={{ 
            background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
          }}
        >
          <MessageCircle size={22} />
          <span>{t.whatsapp}</span>
        </a>
      </div>
    </div>
  );
}

// Desktop floating button (shows on larger screens)
export function FloatingCallButton({ language }: StickyCallBarProps) {
  const t = translations[language];

  return (
    <div className="hidden md:flex fixed bottom-6 right-6 z-50 flex-col gap-3">
      {/* WhatsApp Floating Button */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3 px-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105 text-white font-semibold"
        style={{ 
          background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
        }}
        title={t.whatsapp}
      >
        <MessageCircle size={24} />
        <span>{t.whatsapp}</span>
      </a>
      
      {/* Call Floating Button */}
      <a
        href={PHONE_NUMBER}
        className="flex items-center gap-3 px-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105 text-white font-semibold animate-pulse"
        style={{ 
          background: 'linear-gradient(135deg, #F29B70 0%, #E8926A 100%)',
        }}
        title={t.call}
      >
        <Phone size={24} />
        <span>{t.call}</span>
      </a>
    </div>
  );
}
